import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { ProductType, RBTechnical } from 'store/railsBuilder/reducer.types';
import { selectEntitlements } from 'store/user/selectors';

import { TECHNICAL_DEVICE_TYPE } from 'services/data-manager/constants';
import { VodEditorial } from 'services/data-manager/types';

import { getPurchasableProducts } from 'screens/Detail/utils/getPurchasableProducts';

function useAssetTransactions(item: VodEditorial) {
    const entitlements = useSelector(selectEntitlements);

    return useMemo(() => {
        const technical = item?.technicals?.find(
            ({ deviceType }: RBTechnical) =>
                deviceType.includes(TECHNICAL_DEVICE_TYPE),
        );

        return {
            rentOptions: getPurchasableProducts(
                technical,
                ProductType.TRANSACTION,
                entitlements,
            ),
            subscriptionOptions: getPurchasableProducts(
                technical,
                ProductType.SUBSCRIPTION,
                entitlements,
            ),
        };
    }, [entitlements, item.technicals]);
}

export default useAssetTransactions;
